import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link, useParams } from "react-router-dom";
// shikhar-dhawan.webp
import HomeTaboola from "../subcomponents/HomeTaboola";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { searchResult } from "../../redux/actions/searchResultAction";
import HelperScript from "../../utils/helper";
import InjectScript from "../CustomScript";
import CommonContent from "../CommonContent";
import { searchTagResults } from "../../redux/actions/searchTagAction";
import ReactGA from "react-ga4";
import { AllViewCountActionFetchData } from "../../redux/actions/AllViewCountAction";

function SearchResult() {
  const search_limit = 25;
  const [InputSearchValue, setInputSearchValue] = useState("");
  const [CheckGETresult, setCheckGETresult] = useState("");
  const Childmenu = useSelector((state) => state?.ChildmenuReducer);
  const homePrimary = useSelector((state) => state?.HomePrimaryReducer.data);

  // const { 126: Right } = useSelector((state) => state?.widgetReducer?.data);
  // const { 127: Leftone } = useSelector((state) => state?.widgetReducer?.data);
  // const { 128: leftsecond } = useSelector((state) => state?.widgetReducer?.data);

  const [activeTabType, setActiveTabType] = useState(0);
  // const searchValue = useSelector((state) => state?.searchValue?.data);
  const { searchValue } = useParams();

  const { data: searchData } = useSelector(
    (state) => state?.searchResult?.data
  );
  const loading = useSelector((state) => state?.searchResult?.loading);

  // const searchValue = useSelector((state) => state?.searchValue?.data);
  const { 21: assetbaseUrl } = useSelector(
    (state) => state?.SettingReducer?.data
  );

  const homeEntertainment = useSelector(
    (state) => state?.EntertainmentReducer.data
  );

  // Lazy loading states
  const [page, setPage] = useState(1);
  const [allResults, setAllResults] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [lastFetchedPage, setLastFetchedPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // Ref for scroll detection
  const scrollRef = useRef(null);

  let dispatch = useDispatch();

  // useEffect(() => {
  //   if (searchValue) {
  //     setInputSearchValue(searchValue);
  //   }
  // }, [searchValue]);

  useEffect(() => {
    dispatch(AllViewCountActionFetchData(window.location.pathname));
    dispatch(AllViewCountActionFetchData(window.location.pathname));
  }, [window.location.pathname]); // dependency on pathname

  useEffect(() => {
    if (searchValue) {
      // Recover original tag from sessionStorage
      const originalTag = sessionStorage.getItem("tagSlug:" + searchValue);

      if (originalTag) {
        setInputSearchValue(originalTag); // 👈 Use real tag in API
      } else {
        // Fallback: try decoding back (if user manually types URL)
        const decoded = searchValue.replace(/-/g, " ");
        setInputSearchValue(decoded);
      }
    }
  }, [searchValue]);

  // Improved fetch results function
  const fetchResults = useCallback(
    async (pageToFetch = 1, isNewSearch = false) => {
      if (!InputSearchValue && pageToFetch === 1) return;

      // Prevent multiple simultaneous requests
      if (isFetching) return;
      setIsFetching(true);

      try {
        setIsLoadingMore(true);

        // const result = await dispatch(
        //   searchResult(
        //     "?type=" +
        //       activeTabType +
        //       `&keyword=${InputSearchValue.replace(
        //         /-/g,
        //         " "
        //       )}&limit=${search_limit}&page=${pageToFetch}`
        //   )
        // );
        const result = await dispatch(
          searchTagResults(
            "?type=" +
              activeTabType +
              `&keyword=${InputSearchValue}&limit=${search_limit}&page=${pageToFetch}`
          )
        );
        const newData = result?.data || [];

        // Calculate if there are more pages
        // For 120 total records with 25 per page: 120/25 = 4.8 → 5 pages
        // Page 1: 1-25, Page 2: 26-50, Page 3: 51-75, Page 4: 76-100, Page 5: 101-120
        const totalRecordsFromAPI = 220 || 0;
        const totalPagesFromAPI = Math.ceil(totalRecordsFromAPI / search_limit);
        const hasMoreData = pageToFetch < totalPagesFromAPI;

        if (isNewSearch) {
          setAllResults(newData);
          setHasMore(hasMoreData);
          setTotalRecords(totalRecordsFromAPI);
          setTotalPages(totalPagesFromAPI);
        } else {
          setAllResults((prev) => [...prev, ...newData]);
          setHasMore(hasMoreData);
          setTotalRecords(totalRecordsFromAPI);
          setTotalPages(totalPagesFromAPI);
        }

        setIsInitialLoad(false);
      } catch (error) {
        console.error("Error fetching search results:", error);
        setHasMore(false);
      } finally {
        setIsLoadingMore(false);
        setIsFetching(false);
      }
    },
    [InputSearchValue, activeTabType, search_limit]
  );

  // Handle new search or tab change
  useEffect(() => {
    if (InputSearchValue) {
      setPage(1);
      setAllResults([]);
      setHasMore(true);
      setIsInitialLoad(true);
      setIsFetching(false); // Reset the fetching flag
      setLastFetchedPage(0); // Reset last fetched page
      setTotalRecords(0); // Reset total records
      setTotalPages(0); // Reset total pages
      fetchResults(1, true);
    }
  }, [InputSearchValue, activeTabType, fetchResults]);

  // Handle loading more data when page changes
  useEffect(() => {
    if (
      page > 1 &&
      hasMore &&
      !isLoadingMore &&
      !isInitialLoad &&
      !isFetching &&
      page !== lastFetchedPage
    ) {
      // Add a small delay to prevent rapid successive calls
      const timeoutId = setTimeout(() => {
        setLastFetchedPage(page);
        fetchResults(page);
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [
    page,
    hasMore,
    isLoadingMore,
    isInitialLoad,
    isFetching,
    lastFetchedPage,
    totalPages,
    totalRecords,
    fetchResults,
  ]);

  // Simple scroll handler
  const handleScroll = useCallback(() => {
    if (isLoadingMore || !hasMore || isInitialLoad || isFetching) {
      // console.log("Scroll blocked:", {
      //   isLoadingMore,
      //   hasMore,
      //   isInitialLoad,
      //   isFetching,
      //   currentPage: page,
      // });
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPercentage = (scrollTop + windowHeight) / documentHeight;

    // console.log("Scroll position:", {
    //   scrollTop,
    //   windowHeight,
    //   documentHeight,
    //   scrollPercentage: Math.round(scrollPercentage * 100) + "%",
    //   threshold:
    //     Math.round(((documentHeight - 200) / documentHeight) * 100) + "%",
    // });

    // Trigger when user is 200px from bottom
    if (scrollTop + windowHeight >= documentHeight - 200) {
      setPage((prev) => prev + 1);
    }
  }, [isLoadingMore, hasMore, isInitialLoad, isFetching, page]);

  // Simple scroll event listener with debouncing
  useEffect(() => {
    let timeoutId = null;

    const debouncedScroll = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(() => {
        handleScroll();
      }, 150);
    };

    window.addEventListener("scroll", debouncedScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", debouncedScroll);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    // setAllResults(newData);
    ReactGA.event({
      category: "Releated tags Page",
      action: "Releated tag",
      label: InputSearchValue,
    });
  }, [InputSearchValue]);

  // const searchClickHandler = () => {
  //   if (InputSearchValue) {
  //     setPage(1);
  //     setAllResults([]);
  //     setHasMore(true);
  //     setIsInitialLoad(true);
  //     setIsFetching(false); // Reset the fetching flag
  //     setLastFetchedPage(0); // Reset last fetched page
  //     fetchResults(1, true);
  //   } else if (!InputSearchValue) {
  //     dispatch(searchResult("?type=" + activeTabType));
  //   }
  //   setCheckGETresult(1);
  // };

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     searchClickHandler();
  //   }, 1000);
  //   return () => {
  //     clearTimeout(delayDebounceFn);
  //   };
  // }, [InputSearchValue]);

  // const handleKeyDown = (e) => {
  //   setCheckGETresult();
  //   if (e.key === "Enter") {
  //     searchClickHandler();
  //   }
  // };

  const bubbleAutoSearch = (e) => {
    setInputSearchValue(e);
    setTimeout(() => {
      setPage(1);
      setAllResults([]);
      setHasMore(true);
      setIsInitialLoad(true);
      setIsFetching(false); // Reset the fetching flag
      setLastFetchedPage(0); // Reset last fetched page
      fetchResults(1, true);
      setCheckGETresult(1);
    }, 100);
  };

  const searchafter3 =
    "" +
    "<div id='div-gpt-ad-1657965000873-0' style='min-width: 300px; min-height: 100px;'>" +
    "<script>" +
    "window.googletag = window.googletag || { cmd: [] };" +
    "googletag.cmd.push(function () {" +
    "googletag.defineSlot('/22678428348/Mweb_Searchpage_After3article_300X100', [300, 100], 'div-gpt-ad-1657965000873-0').addService(googletag.pubads());" +
    "googletag.pubads().enableSingleRequest();" +
    "googletag.enableServices();" +
    "});" +
    "</script>" +
    "" +
    " <script>" +
    "googletag.cmd.push(function() { googletag.display('div-gpt-ad-1657965000873-0'); });" +
    "</script>" +
    "</div>" +
    "" +
    "";

  let contentGallery = [];
  let content = [];

  allResults?.length > 0 &&
    allResults?.map((els, idx) => {
      if ((idx + 1) % 4) {
        content.push(
          <Link target="_parent" to={`/${els?.url}`} key={`content-${idx}`}>
            <div className="row list-start mt-4 flex-md-row ">
              <div className="col-3 p-0">
                <div className="skeleton-sub">
                  <img
                    loading="lazy"
                    className="img-fluid"
                    alt={els?.media_title}
                    src={assetbaseUrl?.value + els?.media}
                  />
                  {els?.video ? (
                    <p className="playicon-subhome">
                      <i className="fas fa-play"></i>
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col col-9">
                <div className="post-title search-title-color blog-details">
                  <span>
                    <b className="color-red">{els?.tagline}</b>
                  </span>
                  <p className="ellipsis">{els?.title}</p>
                </div>
                <span className="blog-time search-title-color">
                  <i className="far fa-clock"></i>
                  {els?.publish_date}
                </span>
              </div>
            </div>
          </Link>
        );
      } else {
        content.push(
          window.innerWidth < 991 ? (
            <div className="text-center" key={`ad-${idx}`}>
              <InjectScript script={searchafter3} />
            </div>
          ) : (
            ""
          )
        );
      }
    });

  allResults?.length > 0 &&
    allResults?.map((els, idx) => {
      if ((idx + 1) % 4) {
        contentGallery.push(
          <div className="col-md-6" key={`gallery-${idx}`}>
            <Link target="_parent" to={`/${els?.url}`}>
              <div className="single-blog mx-2">
                <img
                  loading="lazy"
                  style={{ width: "100%" }}
                  src={assetbaseUrl?.value + els?.media}
                  className="img-responsive"
                  alt={els?.media_title}
                />
                <div className="blog-details">
                  <span>
                    <b className="color-red">{els?.tagline}</b>
                  </span>
                  <p className="search-title-color ellipsis">{els?.title}</p>
                  <span className="blog-time search-title-color">
                    <i className="far fa-clock"></i>
                    {els?.publish_date}
                  </span>
                </div>
              </div>
            </Link>
          </div>
        );
      } else {
        contentGallery.push(
          window.innerWidth < 991 ? (
            <div className="text-center" key={`gallery-ad-${idx}`}>
              <InjectScript script={searchafter3} />
            </div>
          ) : (
            ""
          )
        );
      }
    });

  return (
    <>
      <section className="result gujarat isCategoryPage" ref={scrollRef}>
        <div className="container">
          <div className="row mt-3">
            <div className="col-md-9 searchpage">
              <div style={{ opacity: loading && isInitialLoad ? "0.1" : 1 }}>
                <div className="guj-metro-carousel mb-2 d-flex">
                  <div className="nav-item bg-gray">
                    <a
                      className={`${activeTabType === 0 ? "" : ""}`}
                      data-toggle="tab"
                      href="#"
                      onClick={() => setActiveTabType(0)}
                    >
                      {/* All Results of */}
                    </a>
                  </div>
                  {/* <div className="nav-item bg-gray">
                    <a
                      className={`nav-link guj-metro-carousel-tabs ${
                        activeTabType === 1 ? "active-search-result-tab" : ""
                      }`}
                      data-toggle="tab"
                      href="#"
                      onClick={() => setActiveTabType(1)}
                    >
                      News
                    </a>
                  </div>
                  <div className="nav-item bg-gray">
                    <a
                      className={`nav-link guj-metro-carousel-tabs ${
                        activeTabType === 2 ? "active-search-result-tab" : ""
                      }`}
                      data-toggle="tab"
                      href="#"
                      onClick={() => setActiveTabType(2)}
                    >
                      Photos
                    </a>
                  </div>
                  <div className="nav-item bg-gray">
                    <a
                      className={`nav-link guj-metro-carousel-tabs ${
                        activeTabType === 3 ? "active-search-result-tab" : ""
                      }`}
                      data-toggle="tab"
                      href="#"
                      onClick={() => setActiveTabType(3)}
                    >
                      Videos
                    </a>
                  </div> */}

                  {/* <li onClick={() => setActiveTabType(0)} className="nav-item">
                                    <a className="nav-link active" href="#all" data-toggle="tab">બધા</a>
                                </li>
                                <li onClick={() => setActiveTabType(1)} className="nav-item">
                                    <a className="nav-link" href="#news" data-toggle="tab">સમાચાર</a>
                                </li>
                                <li onClick={() => setActiveTabType(2)} className="nav-item">
                                    <a className="nav-link" href="#videos" data-toggle="tab">વિડિઓઝ</a>
                                </li>
                                <li onClick={() => setActiveTabType(3)} className="nav-item">
                                    <a className="nav-link" href="#photos" data-toggle="tab">ફોટા</a>
                                </li> */}

                  {/* <li className="nav-item">
                                    <a className="nav-link" href="#webstories" data-toggle="tab">વેબ વાર્તાઓ</a>
                                </li> */}
                </div>
                <div className="tab-content clearfix">
                  <Helmet>
                    {/* <title>Search | Sandesh </title> */}
                    <title>
                      {InputSearchValue
                        ? `${InputSearchValue} | News In Gujarati `
                        : "Search"}
                    </title>
                    <meta name="description" content="Search" />
                  </Helmet>
                  {InputSearchValue.length ? (
                    <>
                      <h2 className="d-none text-capitalize d-block">
                        '{InputSearchValue.replace(/-/g, " ")}' વિષય પર{" "}
                        {/* {allResults?.length} */}
                        સમાચાર વાંચો
                      </h2>
                    </>
                  ) : (
                    <></>
                  )}
                  {activeTabType === 0 && (
                    <div className="tab-pane active" id="all">
                      <div className={`shadow p-3 mb-3 bg-white rounded `}>
                        <div className="row">
                          <div className="col-xl-8 megapreView col-lg-12">
                            {allResults?.length > 0 &&
                              allResults?.map((els, idx) => (
                                <React.Fragment key={`main-${idx}`}>
                                  {idx === 0 && (
                                    <Link
                                      target="_parent"
                                      to={`/${els?.url}`}
                                      className="story"
                                      title={els?.title}
                                    >
                                      <div className="caption mb-0">
                                        <img
                                          loading="lazy"
                                          src={assetbaseUrl?.value + els?.media}
                                          alt={`${els?.media_title}`}
                                        />
                                        {els?.video ? (
                                          <p className="playicon-subhome">
                                            <i className="fas fa-play"></i>
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                        {(els?.is_live == 1 || els?.tagline) && (
                                          <div className="live-tagline-container" style={{ margin: "10px", width: "auto" }}>
                                            {els?.is_live == 1 && (
                                              <span className="live-now-badge">
                                                <span className="live-now-dot"></span>
                                                LIVE
                                              </span>
                                            )}
                                            {els?.tagline && (
                                              <span className="live-tagline-text" style={{ color: "#ffffff" }}>
                                                {els?.tagline}
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                      <div className="categoty-main-post-title">
                                        <p className="text-white ellipsis">
                                          {els?.title}
                                        </p>
                                        <p className="text-white font-size-small blog-time">
                                          <i className="far fa-clock mr-2"></i>
                                          {els?.publish_date}
                                        </p>
                                      </div>
                                    </Link>
                                  )}
                                </React.Fragment>
                              ))}
                          </div>
                          <div className="col-xl-4 col-lg-12">
                            <div className="right-top-post">
                              {allResults?.length > 0 &&
                                allResults?.map((els, idx) => (
                                  <React.Fragment key={`side-${idx}`}>
                                    {idx > 0 && idx < 5 ? (
                                      <Link
                                        target="_parent"
                                        to={`/${els?.url}`}
                                        className="related-blogs"
                                      >
                                        <p className="img-16-9-blogs eskeleton">
                                          <div
                                            className="col p-0"
                                            style={{ width: "100px" }}
                                          >
                                            <span className="skeleton">
                                              <img
                                                loading="lazy"
                                                src={
                                                  assetbaseUrl?.value +
                                                  els?.media
                                                }
                                                alt={els?.media_title}
                                                className="img-responsive"
                                              />
                                              {els?.video ? (
                                                <p className="playicon-subhome-subcategory">
                                                  <i className="fas fa-play"></i>
                                                </p>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                            <p className="blog-time mt-1 m-0">
                                              <i className="far fa-clock mr-2"></i>
                                              {els?.publish_date}
                                            </p>
                                          </div>
                                        </p>
                                        <div className="col-8 p-0">
                                          <div className="blog-details">
                                            {(els?.is_live == 1 || els?.tagline) && (
                                              <div className="live-tagline-container">
                                                {els?.is_live == 1 && (
                                                  <span className="live-now-badge">
                                                    <span className="live-now-dot"></span>
                                                    LIVE
                                                  </span>
                                                )}
                                                {els?.tagline && (
                                                  <span className="live-tagline-text">
                                                    {els?.tagline}
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                            <p className="ellipsis">
                                              {els?.title}
                                            </p>
                                          </div>
                                        </div>
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </React.Fragment>
                                ))}
                            </div>
                          </div>
                        </div>
                        <div className="row substory">
                          {allResults?.length > 0 &&
                            allResults?.map((els, idx) => (
                              <React.Fragment key={`sub-${idx}`}>
                                {idx > 4 && (
                                  <div className="col-lg-6 col-xl-4">
                                    <Link
                                      target="_parent"
                                      to={`/${els?.url}`}
                                      className="story"
                                    >
                                      <div className="caption mb-0">
                                        <img
                                          loading="lazy"
                                          src={assetbaseUrl?.value + els?.media}
                                          alt={`${els?.media_title}`}
                                        />
                                        {els?.video ? (
                                          <p className="playicon-subhome">
                                            <i className="fas fa-play"></i>
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      <div className="categoty-padding">
                                        {(els?.is_live == 1 || els?.tagline) && (
                                          <div className="live-tagline-container" style={{ marginBottom: "4px" }}>
                                            {els?.is_live == 1 && (
                                              <span className="live-now-badge">
                                                <span className="live-now-dot"></span>
                                                LIVE
                                              </span>
                                            )}
                                            {els?.tagline && (
                                              <span className="live-tagline-text">
                                                {els?.tagline}
                                              </span>
                                            )}
                                          </div>
                                        )}
                                        <p className="ellipsis">{els?.title}</p>
                                        <span className="text-secondary blog-time">
                                          <i className="far fa-clock mr-2"></i>
                                          {els?.publish_date}
                                        </span>
                                      </div>
                                    </Link>
                                  </div>
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTabType === 1 && (
                    <div className="tab-pane active" id="news">
                      {content}
                    </div>
                  )}
                  {activeTabType === 2 && (
                    <div className="tab-pane" id="videos">
                      <div className="row substory">{contentGallery}</div>
                    </div>
                  )}
                  {activeTabType === 3 && (
                    <div className="tab-pane active" id="photos">
                      {content}
                    </div>
                  )}

                  {/* Loading indicator */}
                  {isLoadingMore && (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading more...</span>
                      </div>
                      {/* <p className="mt-2 text-muted">Loading more results...</p>   */}
                    </div>
                  )}

                  {/* No more results message */}
                  {!hasMore && allResults.length > 0 && !isLoadingMore && (
                    <div className="text-center py-4 text-muted">
                      <p>No more results to load</p>
                    </div>
                  )}

                  {/* No results message */}
                  {!isInitialLoad &&
                    allResults.length === 0 &&
                    !isLoadingMore && (
                      <div className="text-center py-4">
                        <p>No results found for "{InputSearchValue}"</p>
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="text-center left-fixed">
                <div className="ad-side-head ">
                  <div className="ad-side m-0">
                    {/* <img loading="lazy" src="https://i.imgur.com/B7MT0G8.png" alt="" /> */}
                    {/* {Leftone?.[0]?.script && */}
                    <div className="ad-section">
                      <HelperScript argSmall={222} argLarge={127} />
                      {/* <InjectScript script={Leftone?.[0]?.script} /> */}
                    </div>
                    {/* } */}
                  </div>
                  <div className="ad-side mt-4">
                    {/* {leftsecond?.[0]?.script &&  */}
                    <div className="ad-section">
                      <HelperScript argSmall={223} argLarge={128} />
                      {/* <InjectScript script={leftsecond?.[0]?.script} /> */}
                    </div>
                    {/* } */}
                    {/* <iframe
                                            title='Currency Converter'
                                            src='https://s.tradingview.com/embed-widget/market-overview/'
                                            width="100%"
                                            height="300"
                                            frameBorder="0"
                                            scrolling="no"
                                        /> */}
                  </div>
                  <div className="shadow rightBar p-x2 mt-4 mb-2 bg-f7f7f7 rounded">
                    <div className="featured ">
                      <a href="javascript:void(0)" className="title">
                        Top 10 News
                      </a>
                      <div className="scroll s-story">
                        {homePrimary?.Trending?.length > 0 &&
                          homePrimary?.Trending?.map((els, idx) => (
                            <React.Fragment key={`trending-${idx}`}>
                              <CommonContent
                                url={els?.url}
                                bgcolorclass="bgcolorcard"
                                dataclass="top10"
                                src={`${assetbaseUrl?.value}${els?.media}`}
                                post_type={els?.post_type}
                                publish_date={els?.publish_date}
                                category={els?.category}
                                title={els?.title}
                                icname={"Share-icon" + idx}
                              />
                              <hr className="border-bt" />
                            </React.Fragment>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <HomeTaboola key={Math.random()} />
      </section>
    </>
  );
}

export default SearchResult;
